<template>
<div class="p-gmap">
  <GmapMap
    v-if="center !== null"
    :center="center"
    :zoom="zoom"
    map-type-id="terrain"
    class="p-gmap--schoolarea"
  >
    <GmapMarker
      :key="index"
      v-for="(m, index) in this.makerList"
      :position="m.position"
      :clickable="true"
      :icon="markerOptions"
      :draggable="false"
      @click="gotoDetail(m.id)"
    />
  </GmapMap>
</div>
</template>

<script>
export default {
  name: 'SchoolAreaGoogleMap',
  props: ['center', 'makerList', 'zoom'],
  data() {
    return {
      markerOptions: {
        // eslint-disable-next-line global-require
        url: require('@/assets/images/icon_house@2x.png'),
        size: { width: 48, height: 48, f: 'px', b: 'px' },
        scaledSize: { width: 48, height: 48, f: 'px', b: 'px' },
      },
    };
  },
  created() {
  },
  methods: {
    gotoDetail(id) {
      if (location.pathname.match(/\/kodate\/[0-9].*/) === null) {
        location.href = `/kodate/${id}/`;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@charset 'UTF-8';

.p-gmap{
      position: relative;

  &--schoolarea {
    width: 100%;
    height: 329.25px;
  }
  .gm-style {
    img {
      position:absolute;
    }
  }
  *:not(table), *:not(table) * {
      position:initial;
  }
}

</style>
